import { API_HEADER_STORE_ID, API_HEADER_HOST } from '../constants'

type headerType = {
  [API_HEADER_HOST]: string
}

export const useHeaderStore = () => {
  const state = useState<headerType>(API_HEADER_STORE_ID, () => ({
    [API_HEADER_HOST]: '',
  }))

  const isApp = computed(() => {
    const runtimeConfig = useRuntimeConfig()
    return state.value[API_HEADER_HOST]?.includes(
      runtimeConfig.public.NATIVE_APP_HOST,
    )
  })
  const setHost = (newValue: string) => {
    state.value[API_HEADER_HOST] = newValue
  }

  return {
    state,
    isApp,
    setHost,
  }
}
